<script setup>
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';
const settings = defineModel({ type: Object, required: true });
const { t } = useI18n();
const modeOptions = [
  { value: 'round_robin', label: t('CAMPAIGN.ROTATION.MODE.ROUND_ROBIN') },
  { value: 'random', label: t('CAMPAIGN.ROTATION.MODE.RANDOM') },
];
</script>
<template>
  <fieldset class="flex flex-col gap-3 p-4 border rounded-lg border-n-weak">
    <legend class="px-1 text-sm font-medium text-n-slate-12">
      {{ t('CAMPAIGN.ROTATION.TITLE') }}
    </legend>
    <div class="flex flex-col gap-1">
      <label class="text-sm font-medium text-n-slate-12">{{ t('CAMPAIGN.ROTATION.MODE.LABEL') }}</label>
      <ComboBox v-model="settings.mode" :options="modeOptions" />
    </div>
    <div class="grid grid-cols-2 gap-3">
      <Input v-model="settings.message_delay" type="number" min="0" step="0.1" :label="t('CAMPAIGN.ROTATION.MESSAGE_DELAY')" />
      <Input v-model="settings.batch_size" type="number" min="1" step="1" :label="t('CAMPAIGN.ROTATION.BATCH_SIZE')" />
      <Input v-model="settings.batch_delay" type="number" min="0" step="0.1" :label="t('CAMPAIGN.ROTATION.BATCH_DELAY')" />
      <Input v-model="settings.inbox_reuse_delay" type="number" min="0" step="0.1" :label="t('CAMPAIGN.ROTATION.INBOX_REUSE_DELAY')" />
      <Input v-model="settings.jitter" type="number" min="0" step="0.1" :label="t('CAMPAIGN.ROTATION.JITTER')" />
    </div>
    <p class="text-xs text-n-slate-11">{{ t('CAMPAIGN.ROTATION.HELP') }}</p>
  </fieldset>
</template>
